import { useAuth } from './useAuth'
import { useFriendships } from './useFriendships'
import { usePendingGroupInvites } from './usePendingGroupInvites'
import { useAdminGroupSuggestions } from './useAdminGroupSuggestions'
import { useCrewTicketActions } from './useCrewTicketActions'

/**
 * Everything waiting on the viewer in Crew — incoming friend requests, group
 * invites, events suggested to groups they admin, and tickets to act on. Each
 * counts toward the Crew nav badge until it's resolved.
 */
export function useCrewInboxCount(): number {
  const { signedInUid } = useAuth()
  const { incoming } = useFriendships(signedInUid)
  const { pendingInvites } = usePendingGroupInvites(signedInUid)
  const { suggestions } = useAdminGroupSuggestions(signedInUid)
  const tickets = useCrewTicketActions(signedInUid)
  return incoming.length + pendingInvites.length + suggestions.length + tickets.items.length
}
